import React from "react";
import { MenuURL } from "../../Constants/GlobalConstant";
import Button from "@mui/material/Button";
const ImageUploadButton = ({ divisionId, sessionId }) => {
  const openImageUploadPopup = (event) => {
    event.preventDefault();
    let URL =
      `${MenuURL}` +
      `/Pages/production/maintenance/RBO/UploadImage.aspx?division_id=${divisionId}&` +
      `session_id=` +
      sessionId;
    window.open(URL, "_blank", "width=600,height=400");
  };

  return (
    <Button variant="contained" onClick={openImageUploadPopup}>
      Upload Image
    </Button>
  );
};

export default ImageUploadButton;
